// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.payment-modal__field--select .sk-select__list {\n  max-height: 132px;\n}\n", ""]);
// Exports
module.exports = exports;
